module.exports = __webpack_public_path__ + "public/files/img/masrufi.4225f5d7.gif";